import { render, staticRenderFns } from "./EmailAndSms.vue?vue&type=template&id=6cd74d68&scoped=true&"
import script from "./EmailAndSms.vue?vue&type=script&lang=js&"
export * from "./EmailAndSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd74d68",
  null
  
)

export default component.exports